require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-window-shopping-physiology.json") })
        }
      }, "path---blog-window-shopping-physiology");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-window-shopping-physiology!./.cache/json/blog-window-shopping-physiology.json
// module id = 313
// module chunks = 231608221292675